import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import Session from './Session';
import ViewableMixin from './ViewableMixin';
import twitterText from 'twitter-text';

var Speaker = Backbone.RelationalModel.extend({

    relations: [
        {
            type: Backbone.HasMany,
            key: 'sessions',
            relatedModel: Session,
            collectionType: Backbone.Collection
        }
    ],

    defaults: {
        'markersData': {}
    },

    sendLike: function(options) {
        const thisModel = this;
        const shouldLike = options.shouldLike;
        const success = options.success;
        const method = shouldLike? 'POST': 'DELETE';
        const data = {
            markerType: 'like',
            entity: 'speakers',
            entityId: this.get('id'),
            eventId: Global.get('event').get('id')
        };
        options.success = function() {
            const markersData = thisModel.get('markersData');
            if (shouldLike) {
                markersData.likes = markersData.likes ? markersData.likes + 1 : 1;
            } else {
                markersData.likes = markersData.likes ? markersData.likes - 1 : null;
            }
            markersData.like = shouldLike;
            thisModel.trigger('speakerLike');
            success && success();
        };

        Backbone.ajax({
            url: '/api/v2/userProfile/markers',
            method: method,
            data,
            success: options.success,
            error: options.error
        });
    },

    like: function(options) {
        options = options || {};
        options.shouldLike = true;
        this.sendLike(options);
    },

    unLike: function(options) {
        options = options || {};
        options.shouldLike = false;
        this.sendLike(options);
    },

    fullName: function() {
        return _.compact([
            this.get('first-name'),
            this.get('last-name')
        ]).join(' ');
    },

    toJSON: function() {
        var toJSON = Backbone.RelationalModel.prototype.toJSON.call(this);
        var bio = toJSON.bio && toJSON.bio.toString();
        toJSON.safeHtmlDescription = twitterText.autoLinkUrlsCustom(twitterText.htmlEscape(bio || ''), {urlTarget: '_top'});
        return toJSON;
    }

});
_.extend(Speaker.prototype, ViewableMixin);

export default Speaker;

